import _ from 'lodash';
import { OrderedMap } from 'immutable';
import OrderConstants from '../constants/OrderConstants';
import OrderStore from '../stores/OrderStore';
import Order from '../models/Order';

const OrderActions = {
  list(context, payload) {
    payload.pagination = payload.pagination || OrderStore.defaultPagination;
    payload.sorter = payload.sorter || OrderStore.defaultSorter;
    payload.filters = payload.filters || [];

    if(context.getCurrentStore()) {
      payload.filters.push({type: 'store_id', value: context.getCurrentStore().id});
    }

    let requestPayload = {
      filters: payload.filters,
      pagination: payload.pagination,
      sort: [payload.sorter]
    };

    context.dispatch(OrderConstants.LIST_ORDERS_START, payload);

    return context
      .delectoryApi
      .orders
      .list(requestPayload)
      .then(responsePayload => {
        let orders = responsePayload.orders.reduce((map, order) => {
          return map.set(order.id, new Order(order));
        }, new OrderedMap());
        payload.pagination.totalResults = responsePayload.total_results;
        context.dispatch(OrderConstants.LIST_ORDERS_SUCCESS, {
          entities: orders,
          filters: payload.filters,
          pagination: payload.pagination,
          sorter: payload.sorter
        });
      })
      .catch(err => {
        context.dispatch(OrderConstants.LIST_ORDERS_FAILURE, {error: err});
      });
  },

  fetch(context, payload) {
    context.dispatch(OrderConstants.FETCH_ORDER_START, payload.id);
    return context
      .delectoryApi
      .orders
      .order({id: payload.id})
      .then(responsePayload => {
        let order = new Order(responsePayload.order);
        context.dispatch(OrderConstants.FETCH_ORDER_SUCCESS, order);
        context.dispatch(OrderConstants.SET_CURRENT_ORDER, order.id);
      })
      .catch(err => {
        context.dispatch(OrderConstants.FETCH_ORDER_FAILURE, {entityId: payload.id, error: err});
      });
  }
};

export default OrderActions;



// WEBPACK FOOTER //
// banquet/actions/OrderActions.js